import React from 'react';
import { Badge, Button, Card } from 'antd';
import './QuickActionsCard.css';
import { MacCommandOutlined } from '@ant-design/icons';

interface QuickAction {
  id: string;
  icon: React.ReactNode;
  label: string;
  onClick?: () => void;
  comingSoon?: boolean;
  disabled?: boolean;
}

interface QuickActionsCardProps {
  actions: QuickAction[];
}

const QuickActionsCard: React.FC<QuickActionsCardProps> = ({ actions }) => {
  return (
    <Card className="quick-actions-card">
      <div className="quick-actions-card__header">
        <div className="quick-actions-card__icon-wrapper">
          <MacCommandOutlined style={{ fontSize: 24, color: '#10b981' }} />
        </div>
        <span className="quick-actions-card__title">ACTIONS RAPIDES</span>
      </div>
      <div className="quick-actions-card__list">
        {actions.map((action) => (
          <Button
            key={action.id}
            type="primary"
            variant='outlined'
            size='large'
            icon={action.icon}
            className={`quick-actions-card__btn ${
              action.comingSoon ? 'quick-actions-card__btn--coming-soon' : ''
            }`}
            onClick={action.comingSoon ? undefined : action.onClick}
            disabled={action.comingSoon || action.disabled}
          >
            <span style={{ textAlign: 'left', width: '100%' }}>{action.label}</span>
            {action.comingSoon && <Badge count="Soon" className="soon-badge" />}
          </Button>
        ))}
      </div>
    </Card>
  );
};

export default QuickActionsCard;
